import {
  Statistic as AntdStatistic,
  StatisticProps as AntdStatisticProps,
} from 'antd';

function Statistic(props: AntdStatisticProps) {
  return <AntdStatistic {...props} decimalSeparator="," groupSeparator="." />;
}

export default Statistic;
